var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',{attrs:{"col":_vm.cols}},_vm._l((_vm.items),function(item){return _c(_vm.thumb(),{key:item,tag:"component",class:['skeleton', ("skeleton--" + _vm.thumbComponent)]})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }